import React from "react";
import { gql } from "apollo-boost";

import StatusBadge from "designV2/components/StatusBadge";
import SettingsList, { enumOptions, humanize } from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createReadyMessageByAdmin($message: String!, $order: Int!, $type: ReadyMessageType!) {
    createReadyMessageByAdmin(input: { message: $message, order: $order, type: $type }) {
      _id
      message
      order
      type
    }
  }
`;

const GET = gql`
  query getReadyMessagesByAdmin($limit: Int, $skip: Int) {
    getReadyMessagesByAdmin(pagination: { limit: $limit, skip: $skip }) {
      _id
      message
      type
      order
    }
  }
`;

const COUNT = gql`
  query getReadyMessagesByAdminCount {
    getReadyMessagesByAdminCount
  }
`;

const UPDATE = gql`
  mutation updateReadyMessageByAdmin(
    $id: ID!
    $message: String!
    $order: Int!
    $type: ReadyMessageType!
  ) {
    updateReadyMessageByAdmin(id: $id, input: { message: $message, order: $order, type: $type }) {
      _id
      message
      order
      type
    }
  }
`;

const DELETE = gql`
  mutation removeReadyMessageByAdmin($idSet: [ID!]!) {
    removeReadyMessageByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const TYPES = ["TAXI", "DELIVERY"];

const FIELDS = [
  { name: "message", label: "Message", type: "text", required: true },
  {
    name: "type",
    label: "Shown during",
    type: "select",
    required: true,
    options: enumOptions(TYPES),
  },
  {
    name: "order",
    label: "Position",
    type: "number",
    required: true,
    defaultValue: 0,
    hint: "Lower numbers appear first in the app.",
  },
];

/**
 * ReadyMessages - the tap-to-send lines in the trip chat.
 *
 * Drivers and passengers use these instead of typing while moving, so
 * the order matters: it decides what is within thumb's reach.
 */
const ReadyMessages = () => (
  <SettingsList
    title="Ready messages"
    description="The one-tap replies drivers and passengers send during a trip."
    singular="message"
    list={{ query: GET, key: "getReadyMessagesByAdmin" }}
    count={{ query: COUNT, key: "getReadyMessagesByAdminCount" }}
    create={{
      mutation: ADD,
      variables: (values) => ({
        message: values.message.trim(),
        type: values.type,
        order: parseInt(values.order, 10) || 0,
      }),
    }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({
        id: row._id,
        message: values.message.trim(),
        type: values.type,
        order: parseInt(values.order, 10) || 0,
      }),
    }}
    remove={{ mutation: DELETE }}
    columns={[
      { key: "message", label: "Message", width: "3fr" },
      {
        key: "type",
        label: "Shown during",
        render: (row) => (
          <StatusBadge
            status={row.type === "TAXI" ? "info" : "accent"}
            label={humanize(row.type)}
          />
        ),
      },
      { key: "order", label: "Position", width: "90px" },
    ]}
    fields={FIELDS}
    toValues={(row) => ({ message: row.message, type: row.type, order: row.order })}
  />
);

export default ReadyMessages;
